import { render, staticRenderFns } from "./edittext.vue?vue&type=template&id=b80bc40a&scoped=true"
import script from "./edittext.vue?vue&type=script&lang=js"
export * from "./edittext.vue?vue&type=script&lang=js"
import style0 from "./edittext.vue?vue&type=style&index=0&id=b80bc40a&prod&lang=scss&scoped=true"
import style1 from "./edittext.vue?vue&type=style&index=1&id=b80bc40a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80bc40a",
  null
  
)

export default component.exports